import React, { useState } from "react";
import styled from "styled-components";
import { P, Link } from "../";
export const ExpandingText = ({
  text,
  count,
  label = {
    less: "See Less",
    more: "See More"
  },
  ...props
}) => {
  const [expand, setExpand] = useState(false);
  let textLength = text.length;
  return textLength >= count ? /*#__PURE__*/React.createElement(P, props, expand ? text : text.substr(0, count), " ... ", /*#__PURE__*/React.createElement(SeeMoreLink, {
    onClick: () => setExpand(!expand)
  }, expand ? label.less : label.more)) : /*#__PURE__*/React.createElement(P, props, text);
};
const SeeMoreLink = styled(Link)`
  display: inline-block;
  font-size: 15px;
  line-height: 19px;
  ${props => props.theme.dark && `color: white;`};
`;